module.exports = "/resources/assets/prod/287af2189c8b373d14643f0d0741dd53.svg";